var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-cart-upsell-switch');
  if (!btn) return;

  const banner = btn.closest('.cart-upsell-banner');
  const lineIndex = banner.dataset.lineIndex;
  const variantId = banner.dataset.variantId;

  const upsellMap = {
    '46911903039711': '50584056463583', // spicy icon [black] > spicy icon [black] + urban wonder [black]
    '46911903072479': '50584056594655', // spicy icon [natural] > spicy icon [natural] + urban wonder [natural]
    '46910336270559': '50584045715679', // soft girl [black] > soft girl [black] + urban wonder [black]
    '46910336303327': '50584045846751', // soft girl [natural] > soft girl [natural] + urban wonder [natural]
    '46910336336095': '50584045977823', // soft girl [blonde] > soft girl [blonde] + urban wonder [blonde]
    '46911902220511': '50624306708703', // soft madame [black] > soft madame [black] + mother [black]
    '46911902253279': '50624307036383', // soft madame [merlot] > soft madame [merlot] + mother [dark-cherry]
    '46911902286047': '50624306872543', // soft madame [natural] > soft madame [natural] + mother [black]
    '46911902318815': '50624306938079', // soft madame [ginger] > soft madame [ginger] + mother [chocolate]
    '50571783733471': '51051537957087', // dolly star [black] > dolly star [black] + mother [black]
    '49083766702303': '51051538219231', // dolly star [merlot] > dolly star [merlot] + mother [dark-cherry]
    '49083766735071': '51051538055391'  // dolly star [natural] > dolly star [natural] + mother [black]
  };

  const comboVariantId = upsellMap[variantId];
  if (!comboVariantId) return;

  btn.disabled = true;
  btn.textContent = 'Getting deal...';

  fetch(window.routes.cart_change_url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line: lineIndex, quantity: 0 })
  })
  .then(res => res.json())
  .then(() => fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      items: [{ id: comboVariantId, quantity: 1 }],
      sections: ['cart-drawer'],
      sections_url: window.location.pathname
    })
  }))
  .then(res => res.json())
  .then(result => {
    const addedItem = result && result.items && result.items[0];
    const swapped = addedItem && String(addedItem.variant_id) === String(comboVariantId);
    const drawerHtml = result && result.sections && result.sections['cart-drawer'];

    if (swapped && drawerHtml) {
      const newWrapper = new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector('.js-cart-drawer-wrapper');
      const currentWrapper = document.querySelector('.js-cart-drawer-wrapper');
      if (newWrapper && currentWrapper) {
        currentWrapper.innerHTML = newWrapper.innerHTML;
      } else {
        location.reload();
      }
    } else {
      // Swap didn't actually succeed — don't leave the drawer showing stale state
      location.reload();
    }
  })
  .catch(() => {
    btn.disabled = false;
    btn.textContent = 'Get Deal';
  });
});
